import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const StudentChurnGauge = (props) => (
  <KpiChart
    title="CHURN"
    description="The number represents the percentage of students who have studied in the month prior to the reference month but have not study in the reference month."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[0, 10, 40, 100]}
    stepSize={10}
    reverseColors={true}
    formatter={props.formatter}
    onClickHistory={props.onClickHistory}
  />
);

StudentChurnGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};

StudentChurnGauge.propTypes = {
  onClickHistory: null,
};

export default StudentChurnGauge;
